export function captionText(image: any, gastro: any): string {
  let uploaderText: string[] = [];

  if (image.title) {
    uploaderText = uploaderText.concat([image.title + '\n']);
  }

  uploaderText = uploaderText.concat(['Bild hochgeladen von:']);

  if (image.userUrl) {
    let imageUserName = image.userName;

    if (image.userId === Number(gastro?.owner?.id)) {
      imageUserName = 'Inhaber';
    }

    uploaderText = uploaderText.concat([imageUserName]);
  } else {
    uploaderText = uploaderText.concat(['Gaumenfreund']);
  }

  if (image.createdAt) {
    uploaderText = uploaderText.concat([
      'am ' +
        new Date(image.createdAt).toLocaleDateString('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })
    ]);
  }

  return uploaderText.join(' ');
}
